
import { mapGetters, mapActions } from "vuex";
import AccountForm from "@/components/venda/AccountForm.vue";
import ContactsForm from "@/components/venda/ContactsForm.vue";
import AddressForm from "@/components/venda/AddressForm.vue";
import DocumentsForm from "@/components/venda/DocumentsForm.vue";
import UploadedDocuments from "@/components/venda/UploadedDocuments.vue";
import PaymentInfoForm from "@/components/venda/PaymentInfoForm.vue";
import MembersForm from "@/components/venda/MembersForm.vue";
import SavedMembers from "@/components/venda/SavedMembers.vue";
import checkout from "../../mixins/checkout.mixin.js";

export default {
  name: "EditarVenda",
  data: () => ({
    venda: {},
    uploadedDocuments: [],
    documentsToDelete: [],
    documents: [],
    members: [],
    savedMembers: [],
    membersToDelete: [],
  }),

  mixins: [checkout],

  computed: {
    ...mapGetters("checkout", [
      "PLANO",
      "VALOR_MENSAL",
      "VALOR_INCREMENTAVEL",
      "ASSOCIADOS_LIMITE",
      "DADOS_INTERNOS",
      "CONTRATANTE_TEM_QUE_SER_ASSOCIADO",
    ]),

    id() {
      return this.$route.params.id;
    },
    ...mapGetters("usuario", { usuario: "getUsuario" }),
  },

  methods: {
    ...mapActions("checkout", ["ADICIONA_DADOS_INTERNOS"]),

    changeListOfDocumentsToDelete(val) {
      this.documentsToDelete = val;
    },

    changeListOfMembersToDelete(val) {
      this.membersToDelete = val;
    },

    getVenda() {
      this.$http
        .get("/venda/" + this.id)
        .then((res) => {
          console.log("... getVenda:", res.data);

          let contrato = res.data.contrato;
          this.savedMembers = Array.isArray(res.data.associados) ? res.data.associados : [];
          const ownerMember = res.data.contratante_associado !== undefined && res.data.contratante_associado !== null ? res.data.contratante_associado : contrato.contratante_associado;
          this.contratante_associado = ownerMember === true || ownerMember === 1 || ownerMember === '1' || ownerMember === 'true';

          this.account = {
            nome: contrato.nome,
            profissao: contrato.profissao,
            sexo: contrato.sexo,
            cpf: contrato.cpf,
            rg: contrato.rg,
            rg_orgao_emissor: contrato.rg_orgao_emissor,
            nascimento: contrato.nascimento,
            indicado: contrato.indicado,
          };
          this.contacts = {
            whatsapp: contrato.whatsapp,
            celular: contrato.celular,
            celular_2: contrato.celular_2,
            dono_celular_2: contrato.dono_celular_2,
            telefone: contrato.telefone,
            email: contrato.email,
          };
          this.address = {
            cep: contrato.cep,
            rua: contrato.rua,
            numero: contrato.numero,
            complemento: contrato.complemento,
            cidade: contrato.cidade,
            bairro: contrato.bairro,
            uf: contrato.uf,
          };
          this.payment = {
            forma_pagamento_adesao: contrato.forma_pagamento_adesao,
            forma_pagamento: contrato.forma_pagamento,
            isento_adesao: Boolean(contrato.isento_adesao),
          };
          this.ADICIONA_DADOS_INTERNOS({
            id_produto: contrato.id_produto,
            id_plano: contrato.id_plano,
            nome_produto: contrato.nome_produto,
            nome_plano: contrato.nome_plano,
          });
          this.getDocumentos();
        })
        .catch((err) => {
          console.log(err.response.data);
          this.$notify.error("Houve um erro ao cadastrar a venda");
        });
    },

    getDocumentos() {
      this.$http(`/venda/documento/${this.id}`).then((res) => {
        this.uploadedDocuments = Array.isArray(res.data) ? res.data : [];
      });
    },

    setStatus() {
      return new Promise((resolve, reject) => {
        this.$http
          .put(`/venda/status/${this.id}`, {
            status: "aguardando análise",
            userID: this.usuario.id,
            userName: this.usuario.nome,
          })
          .then(() => resolve())
          .catch((err) => reject(err));
      });
    },

    async salvarVenda() {
      console.log("associados para apagar", this.membersToDelete);
      this.loading("Gravando a Venda. Aguarde um momento");
      let dados_venda = {
        ...this.account,
        ...this.contacts,
        ...this.address,
        ...this.payment,
        valor_adesao: this.valor_adesao,
        contratante_associado: this.contratante_associado,
        status: "aguardando análise",
        documentos: this.documents,
        associados: this.members,
        listaDocumentosApagar: this.documentsToDelete,
        listaAssociadosApagar: this.membersToDelete,
        id_usuario: this.usuario.id, // para deixar no histórico a passoa que esta editando
        nome_usuario: this.usuario.nome, // para deixar no histórico a passoa que esta editando
      };
      await this.$http
        .put("/venda/" + this.id, dados_venda)
        .then(async () => {
          this.$loading(false);
          this.$notify.success({
            msg: "A venda foi gravada com sucesso.",
          });
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$loading(false);
          this.sendingData = false;
          console.log(err);
          this.$notify.error({
            msg: "Houve um erro ao cadastrar a venda",
          });
        });
    },
  },

  mounted() {
    this.getVenda();
  },

  components: {
    AccountForm,
    ContactsForm,
    AddressForm,
    DocumentsForm,
    UploadedDocuments,
    PaymentInfoForm,
    MembersForm,
    SavedMembers,
  },
};
